import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'lineBreak',
    standalone: false
})
export class LineBreakPipe implements PipeTransform {
    transform(value: string): string {
        if (!value) return '';
        return value.replace(/\n/g, '<br>'); // Replace all \n with <br>
    }
}
